module.exports = __webpack_public_path__ + "static/img/nobill.833ce98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nobill.png
// module id = BMcU
// module chunks = 1